import react, { useEffect } from "react";
import { Box, Typography, Slider, Paper } from "@mui/material";
import { alpha, styled } from "@mui/system";
import muiTheme from "../../themes/muiTheme";
import { red } from "@mui/material/colors";

const SliderContainer = styled(Box)(() => ({
  [muiTheme.breakpoints.up("sm")]: {
    display: "flex",
    height: 56,
    alignItems: "center",
    position: "fixed",
    bottom: 24,
    paddingLeft: 12,
    paddingRight: 24,
    borderRadius: 99,
    justifyContent: "end",
    zIndex: 2,
    boxShadow: "0px 4px 8px 0px rgba(0, 0, 0, 0.10)",
    backgroundColor: alpha(muiTheme.palette.white, 0.8),
  },

  [muiTheme.breakpoints.down("sm")]: {
    display: "flex",
    height: 60,
    alignItems: "center",
    position: "fixed",
    bottom: 0,
    marginLeft: 0,
    paddingLeft: 18,
    paddingRight: 18,
    borderRadius: 0,
    justifyContent: "end",
    zIndex: 2,
    boxShadow: 0,
    backgroundColor: "transparent",
  },
}));

interface Props {
  currentPage: number;
  allPage: number;
  setPage: React.Dispatch<React.SetStateAction<number>>;
}

export const SliderBar = ({ currentPage, allPage, setPage }: Props) => {
  return (
    <SliderContainer>
      <Box sx={{ alignItems: "center", padding: 0 }}>
        <Slider
          step={1}
          min={1}
          max={allPage}
          defaultValue={0}
          value={currentPage}
          onChange={(event, newValue) => {
            setPage(Number(newValue));
          }}
          valueLabelDisplay="auto"
          sx={{
            flex: 1,
            width: { lg: 270, xs: 200 },
            ml: { lg: 2, xs: 1.8 },
            mr: { lg: 1, xs: 1.8 },
            " & .MuiSlider-thumb: hover": {
              boxShadow: 0,
              "@media (hover: none)": {
                boxShadow: 0,
              },
            },
            " & .MuiSlider-thumb: active": {
              boxShadow: 0,
              "@media (hover: none)": {
                boxShadow: 0,
              },
            },
            " & .MuiSlider-rail": {
              bgcolor: muiTheme.palette.alpha.blue12,
            },
          }}
        />
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: { lg: 88, xs: 72 },
            height: 10,
            gap: 0.4,
            mr: { lg: 0, sm: 0, md: 0, xs: 2 },
          }}
        >
          <Typography
            sx={{
              color: muiTheme.palette.black,
              width: { lg: 28, xs: 28 },
              fontVariant: { lg: "tm-b", xs: "tm-m" },
              textAlign: "right",
            }}
          >
            {currentPage}
          </Typography>
          <Box
            component="img"
            src={process.env.PUBLIC_URL + "img/ic_slush_gray.png"}
            sx={{ width: { lg: 8, xs: 5.6 }, height: { lg: 28, xs: 13 } }}
          />
          <Typography
            sx={{
              width: { lg: 28, xs: 28 },
              fontVariant: { lg: "tm-m", xs: "tm-r" },
              color: muiTheme.palette.grey[800],
            }}
          >
            {allPage}
          </Typography>
        </Box>
      </Box>
    </SliderContainer>
  );
};
